import { default as indexQWKFaMHH2OMeta } from "/app/pages/account/index.vue?macro=true";
import { default as indexiP6c8yqbqKMeta } from "/app/pages/account/messenger/index.vue?macro=true";
import { default as _91threadId_93dCoM4RY3KPMeta } from "/app/pages/account/messenger/thread/[threadId].vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as _91slug_93EKTaox3CwZMeta } from "/app/pages/p/[sport]/[slug].vue?macro=true";
import { default as classificationiVQUmFHcVCMeta } from "/app/pages/static/classification.vue?macro=true";
export default [
  {
    name: indexQWKFaMHH2OMeta?.name ?? "account___fr",
    path: indexQWKFaMHH2OMeta?.path ?? "/account",
    meta: indexQWKFaMHH2OMeta || {},
    alias: indexQWKFaMHH2OMeta?.alias || [],
    redirect: indexQWKFaMHH2OMeta?.redirect,
    component: () => import("/app/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexQWKFaMHH2OMeta?.name ?? "account___it",
    path: indexQWKFaMHH2OMeta?.path ?? "/account",
    meta: indexQWKFaMHH2OMeta || {},
    alias: indexQWKFaMHH2OMeta?.alias || [],
    redirect: indexQWKFaMHH2OMeta?.redirect,
    component: () => import("/app/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexiP6c8yqbqKMeta?.name ?? "account-messenger___fr",
    path: indexiP6c8yqbqKMeta?.path ?? "/compte/messenger",
    meta: indexiP6c8yqbqKMeta || {},
    alias: indexiP6c8yqbqKMeta?.alias || [],
    redirect: indexiP6c8yqbqKMeta?.redirect,
    component: () => import("/app/pages/account/messenger/index.vue").then(m => m.default || m)
  },
  {
    name: indexiP6c8yqbqKMeta?.name ?? "account-messenger___it",
    path: indexiP6c8yqbqKMeta?.path ?? "/account/messenger",
    meta: indexiP6c8yqbqKMeta || {},
    alias: indexiP6c8yqbqKMeta?.alias || [],
    redirect: indexiP6c8yqbqKMeta?.redirect,
    component: () => import("/app/pages/account/messenger/index.vue").then(m => m.default || m)
  },
  {
    name: _91threadId_93dCoM4RY3KPMeta?.name ?? "account-messenger-thread-threadId___fr",
    path: _91threadId_93dCoM4RY3KPMeta?.path ?? "/compte/messenger/thread/:threadId()",
    meta: _91threadId_93dCoM4RY3KPMeta || {},
    alias: _91threadId_93dCoM4RY3KPMeta?.alias || [],
    redirect: _91threadId_93dCoM4RY3KPMeta?.redirect,
    component: () => import("/app/pages/account/messenger/thread/[threadId].vue").then(m => m.default || m)
  },
  {
    name: _91threadId_93dCoM4RY3KPMeta?.name ?? "account-messenger-thread-threadId___it",
    path: _91threadId_93dCoM4RY3KPMeta?.path ?? "/account/messenger/thread/:threadId()",
    meta: _91threadId_93dCoM4RY3KPMeta || {},
    alias: _91threadId_93dCoM4RY3KPMeta?.alias || [],
    redirect: _91threadId_93dCoM4RY3KPMeta?.redirect,
    component: () => import("/app/pages/account/messenger/thread/[threadId].vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index___fr",
    path: indexN6pT4Un8hYMeta?.path ?? "/",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index___it",
    path: indexN6pT4Un8hYMeta?.path ?? "/",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93EKTaox3CwZMeta?.name ?? "p-sport-slug___fr",
    path: _91slug_93EKTaox3CwZMeta?.path ?? "/p/:sport()/:slug()",
    meta: _91slug_93EKTaox3CwZMeta || {},
    alias: _91slug_93EKTaox3CwZMeta?.alias || [],
    redirect: _91slug_93EKTaox3CwZMeta?.redirect,
    component: () => import("/app/pages/p/[sport]/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93EKTaox3CwZMeta?.name ?? "p-sport-slug___it",
    path: _91slug_93EKTaox3CwZMeta?.path ?? "/p/:sport()/:slug()",
    meta: _91slug_93EKTaox3CwZMeta || {},
    alias: _91slug_93EKTaox3CwZMeta?.alias || [],
    redirect: _91slug_93EKTaox3CwZMeta?.redirect,
    component: () => import("/app/pages/p/[sport]/[slug].vue").then(m => m.default || m)
  },
  {
    name: classificationiVQUmFHcVCMeta?.name ?? "static-classification___fr",
    path: classificationiVQUmFHcVCMeta?.path ?? "/transparence-classification-produits",
    meta: classificationiVQUmFHcVCMeta || {},
    alias: classificationiVQUmFHcVCMeta?.alias || [],
    redirect: classificationiVQUmFHcVCMeta?.redirect,
    component: () => import("/app/pages/static/classification.vue").then(m => m.default || m)
  },
  {
    name: classificationiVQUmFHcVCMeta?.name ?? "static-classification___it",
    path: classificationiVQUmFHcVCMeta?.path ?? "/trasparenza-classificazione-prodotti",
    meta: classificationiVQUmFHcVCMeta || {},
    alias: classificationiVQUmFHcVCMeta?.alias || [],
    redirect: classificationiVQUmFHcVCMeta?.redirect,
    component: () => import("/app/pages/static/classification.vue").then(m => m.default || m)
  }
]